import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { PIDataSave } from './pi-data-save';
import { IConfigState, IResultState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IPIDataSaveStateProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
  readonly result: IResultState;
}

export type IPIDataSaveConnectProps = IPIDataSaveStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IPIDataSaveStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config,
    result: state.result
  };
}

export const PIDataSaveContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(PIDataSave);
